import { render, staticRenderFns } from "./schgz2026.vue?vue&type=template&id=54e8227a&scoped=true"
import script from "./schgz2026.vue?vue&type=script&lang=js"
export * from "./schgz2026.vue?vue&type=script&lang=js"
import style0 from "./schgz2026.vue?vue&type=style&index=0&id=54e8227a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e8227a",
  null
  
)

export default component.exports